import axios from 'axios';
import { auth, resError } from '@services/Helpers/ServiceInterceptor';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL + '/GenericInjury/',
});

api.interceptors.request.use((config) => auth(config));
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => resError(error)
);

class GenericInjuryService {

    constructor() {
        if (!GenericInjuryService.instance) {
            GenericInjuryService.instance = this;
        }
        return GenericInjuryService.instance;
    };

    search = (filters, p, fields) => {
        return api.post('/search', { filters: Object.keys(filters).length > 0 ? filters : null, page: p, perPage: 100, fields: fields.length ? fields : null });
    };

    create = (entity) => {
        return api.post('/', entity);
    };

    read = (id) => {
        return api.get('/' + id);
    };

    update = (entity) => {
        return api.put('/', entity);
    };

    delete = (id) => {
        return api.delete('/' + id);
    };

}

const instance = new GenericInjuryService();
Object.freeze(instance);

export default instance;